import {useDocumentTitle} from '@refinedev/react-router';
import {useTranslation} from 'react-i18next';

export const Home = () => {
  useDocumentTitle('documentTitle.nemesis');
  const {t} = useTranslation();
  return (
    <div>
      <h1>{t('pages.nemesis.dashboard.title')}</h1>
    </div>
  );
};
